// extracted by mini-css-extract-plugin
module.exports = {"caption":"Caption_caption__U8wyf","body":"Caption_body__3nPUJ","currentCaption":"Caption_currentCaption__m0q0d","timestamp":"Caption_timestamp__1iLhP"};